import _ from 'lodash'
import RenderData from '../../RenderData'
import Render from './render'
import Editor from './editor'
import PropsTemplate from './propsTemplate'
import i18n from '@/i18n'

const name = 'Navigation'

const toolbarItems = [
  {
    tag: name,
    icon: 'el-icon-set-up',
    get label () {
      return i18n.t('microSite.navigation.name')
    },
    isShow: false // todo may need replace with permission
  }
]

const renders = {
  [name]: Render
}

const editors = {
  [name]: Editor
}

function getEditorTitle (renderData) {
  return i18n.t('microSite.navigation.name')
}

function createRenderData (tag, index, parent) {
  const data = {
    props: _.cloneDeep(PropsTemplate)
  }
  const renderData = new RenderData(tag, data, -1, index, parent, null)
  return renderData
}

const module = {
  name,
  toolbarItems,
  renders,
  editors,
  getEditorTitle,
  createRenderData
}

export default module
